import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-youtube',
  templateUrl: './youtube.component.svg',
})
export class YoutubeComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
